<template>
	<div>
		<footer>
		    <div class="footer_center">
		        <div class="container">
					
		            <div class="footer_center_left">
						<div class="footer_top">
							At a glance
						</div>
		                <dl>
		                    <dt ><span>About us</span></dt>
		                    <dd ><router-link to="/who">Who we are </router-link></dd>
		                    <dd ><router-link to="/our">Our Responsibility</router-link></dd>
		                    <dd ><router-link to="/why">Why Choose us </router-link></dd>
		                </dl>
		                <dl>
		                    <dt ><span>Products</span></dt>
                            <dd ><router-link to="/welding">Welding wire</router-link></dd>
		                    <dd ><router-link to="/cco">CCO plate</router-link></dd>
                            <dd ><router-link to="/nihard">High Chromium White Cast Iron</router-link></dd>
		                    <dd ><router-link to="/wear">Wear resistant ceramics</router-link></dd>
		                    <dd ><router-link to="/detail?id=45">Overlay Wear Pipe</router-link></dd>
                            <dd ><router-link to="/detail?id=24">AR steel plate </router-link></dd>
                            
		                    
		                    
		                </dl>
						<dl>
		                    <dt ><span>Applications</span></dt>
		                    <dd ><router-link to="/appliction?cid=1">Mining</router-link></dd>
		                    <dd ><router-link to="/appliction?cid=2">Cement Plant</router-link></dd>
		                    <dd ><router-link to="/appliction?cid=3">Power Plant</router-link></dd>
		                    <dd ><router-link to="/appliction?cid=4">Port</router-link></dd>
		                    <dd ><router-link to="/appliction?cid=5">Steel Mill</router-link></dd>
		                    <dd ><router-link to="/appliction?cid=6">Bulk Material Handling</router-link></dd>
		                </dl>
						
		            </div>
		            <div class="footer_center_right">
						<div class="footer_top">
							Contact
						</div>
		                <dl>
		                    <dt ><span>Call us</span></dt>
		                    <dd ><a href="tel:86 22 84776558">+86 22 84776558</a></dd>
		                </dl>
		                <dl>
		                    <dt ><span>Send us a message</span></dt>
		                    <dd ><a href="mailto:HS@Hisantech.com">HS@Hisantech.com</a></dd>
		                    
		                </dl>
		                <input type="text" class="input_address" v-model="useremail" placeholder="Enter your email address"/>
						<div class="submit">
							Submit
							<img src="../assets/images/icon/right.png" alt="" class="right">
						</div>
						<!-- <img src="../assets/images/header/submit.png" alt="" class="" @click="submitemail()"> -->
						<ul class="lx_icon_box">
							<li><a href="">
						    <img src="../assets/images/icon/facebook.png" alt="" srcset="" class="icon1"/>
						    <img src="../assets/images/icon/facebook1.png" alt="" srcset="" class="icon1"/>
						    </a> </li>
							<li><a href="">
						    <img src="../assets/images/icon/whatsapp.png" alt="" srcset="" class="icon2"/>
						    <img src="../assets/images/icon/whatsapp1.png" alt="" srcset="" class="icon2"/>
						    </a> </li>
							<li><a href="https://www.linkedin.com/company/hisan-tianjin-co-ltd/">
						    <img src="../assets/images/icon/in.png" alt="" srcset="" class="icon3"/>
						    <img src="../assets/images/icon/in1.png" alt="" srcset="" class="icon3"/>
						    </a> </li>
							<li><a href="">
						    <img src="../assets/images/icon/telegram-plane.png" alt="" srcset="" class="icon4"/>
						    <img src="../assets/images/icon/telegram-plane1.png" alt="" srcset="" class="icon4"/>
						    </a> </li>
							<li><a href="">
						    <img src="../assets/images/icon/skype.png" alt="" srcset="" class="icon5"/>
						    <img src="../assets/images/icon/skype1.png" alt="" srcset="" class="icon5"/>
						    </a> </li>
							<li><a href="">
						    <img src="../assets/images/icon/vk.png" alt="" srcset="" class="icon6"/>
						    <img src="../assets/images/icon/vk1.png" alt="" srcset="" class="icon6"/>
						    </a> </li>
						</ul>
					
					</div>
		        </div>
		    </div>
		    
			<div class="footer_bottom">
		        <div class="container">
					<img src="../assets/images/header/logo3.png" alt="" class="logo2">
		            <p>
						
						© Copyright - 2020-2023: All Rights Reserved.
		
					</p>
		        </div>
		    </div>
		</footer>
		
		
		
	</div>
</template>

<script>
	
	import axios from 'axios';
	export default {
		data() {
			return {
				useremail:'',
			}
		},
		methods: {
			submitemail(){
				if(this.useremail==''){
					alert("Enter your email address")
				}else{
					console.log(this.useremail)
					axios({
						method: 'post',
						url:`${this.$apiYf}/liuyan2api.php`,
						data: {
							email:this.useremail
						},
						headers: {'Content-Type': 'multipart/form-data'},
					}).then(res=>{
					    alert(res.data.des)
					})
				}
			}
		}	
	}
	
</script>

<style scoped>

</style>e